module.exports = __webpack_public_path__ + "img/information.297d142.svg";